
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// This function loads external scripts dynamically
export function loadScript(src: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    // Check if script already exists
    if (document.querySelector(`script[src="${src}"]`)) {
      // If the script is already loaded, check if window.google exists
      if (src.includes('maps.googleapis.com') && window.google?.maps) {
        resolve();
        return;
      } else if (!src.includes('maps.googleapis.com')) {
        resolve();
        return;
      }
    }
    
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    
    script.onload = () => {
      // For Google Maps specifically, give a small delay to ensure it's fully initialized
      if (src.includes('maps.googleapis.com')) {
        setTimeout(() => resolve(), 100);
      } else {
        resolve();
      }
    };
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    
    document.head.appendChild(script);
  });
}

/**
 * An array of billing options available for selection.
 * 'one_time' is for non-recurring payments, while the others are for subscriptions.
 */
export const billingOptions = ['one_time', 'daily', 'weekly', 'monthly', 'quarterly', 'yearly'];

/**
 * Determines if a given billing option is a subscription type.
 * 
 * @param value - The billing option to check.
 * @returns True if the billing option is a subscription type, false otherwise.
 */
export function isSubscription(value: string): boolean {
  // Define the subscription billing options
  const subscribedValues = ['daily', 'weekly', 'monthly', 'quarterly', 'yearly'];
  
  // Check if the provided value is a subscription type
  return subscribedValues.includes(value.toLowerCase());
}
